<template>
  <main class="flex flex-1">
    <UContainer class="m-auto w-96 text-center">
      <slot />
    </UContainer>
  </main>
</template>
